import React, { Component } from "react";
import { Link } from "react-router-dom";

import Notification from "./notification.js";
import settings from "./../settings.js";

import Horn from "../assets/horn.svg";
import Loader from "../assets/loader.png";
import Scrollbars from "react-custom-scrollbars";

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: true, data: [] };
  }
  componentDidMount() {
    this.loadData();
  }
  loadData() {
    this.setState({ isLoading: true });
    fetch(
      settings.server_url +
        "get_newsitems/" +
        window.sessionStorage.getItem("sid"),
      {
        method: "POST",
        body: JSON.stringify({
          limit: 100,
          offset: 0,
          showAll: false,
        }),
      }
    )
      .then((res) => res.json())
      .then((response) => {
        this.setState({ data: response, isLoading: false });
      })
      .catch((error) => console.error("Error:", error));
  }
  removeItem(newsID) {
    fetch(
      settings.server_url +
        "set_newsitem_read/" +
        window.sessionStorage.getItem("sid") +
        "/" +
        newsID
    )
      .then((res) => res.json())
      .then((response) => {})
      .catch((error) => console.error("Error:", error));
  }

  clickRemoveHandler = (e, index) => {
    e.preventDefault();

    let newData = this.state.data;
    newData[index].removed = true;

    this.setState({ data: newData });

    this.removeItem(newData[index].nieuws_id);

    setTimeout(() => {
      let newData = this.state.data;
      newData.splice(index, 1);

      this.setState({ data: newData });
    }, 300);
  };

  openNotification = (e, index) => {
    let newData = this.state.data;

    newData[index].opened = true;

    this.setState({ data: newData });
  };

  render() {
    return (
      <div className="gridItem">
        <div className="gridHeader">
          {/*
          <div className="gridHeaderIcon">
            <img src={Horn} alt="" />
          </div>
          */}
          {/*
          <div className="gridHeaderCount news">
            {this.state.data.length | 0}
          </div>
          */}
          <div className="gridHeaderTitle">Nieuws</div>

          <div className="gridHeaderAll">
            <Link to={"/nieuws"} className="">
              Bekijk alle
            </Link>
          </div>
        </div>
        {this.state.isLoading ? (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows loading"></div>
          </Scrollbars>
        ) : this.state.data.length > 0 ? (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows">
              {this.state.data.map((notification, index) => (
                <Notification
                  clickRemoveHandler={(e) => this.clickRemoveHandler(e, index)}
                  openNotification={(e) => this.openNotification(e, index)}
                  notification={notification}
                  key={notification.nieuws_id}
                />
              ))}
            </div>
          </Scrollbars>
        ) : (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows">
              <Notification
                notification={{ nieuws_title: "Geen nieuwe berichten" }}
              />
              <Link
                to={"/nieuws"}
                className="text-left pl-4 py-3 text-underline">
                Bekijk oudere berichten
              </Link>
            </div>
          </Scrollbars>
        )}
      </div>
    );
  }
}

export default Notifications;
